import Skills from './Skills'
import About from './About'
import MoreInfo from './MoreInfo'
import Resume from './Resume'
import Experience from './Experience'
import './pages.css'
// eslint-disable-next-line react/prop-types
const Pages = ({ page, isLost, setIsLost }) => (
  <div className="Pages">
    {page === 'skills' ? <Skills page={page} /> : null}
    {page === 'moreInfo' ? <MoreInfo page={page} /> : null}
    {page === 'resume' ? <Resume /> : null}
    {page === 'experience' ? <Experience /> : null}
    {page === 'about' ? <About page={page} /> : null}
  </div>
)

export default Pages
